import React from 'react';
import GraduationHat from 'src/app/icons/Monospaced/GraduationHat/GraduationHat';
import CurrencyDollar from 'src/app/icons/Monospaced/Currency/CurrencyDollar';
import CalendarDate from 'src/app/icons/Monospaced/Calendar/CalendarDate';
import CodeSnippet from 'src/app/icons/Monospaced/CodeSnippet/CodeSnippet02';
import UserCircle from 'src/app/icons/Monospaced/User/UserCircle';
import Repeat01 from 'src/app/icons/Monospaced/Repeat/Repeat01';
import Stars02 from 'src/app/icons/Monospaced/Stars/Stars02';
import Settings01 from 'src/app/icons/Monospaced/Settings/Settings01';
import MessageChatCircle from 'app/icons/Monospaced/MessageChat/MessageChatCircle';
import ChartBreakoutSquare from 'src/app/icons/Monospaced/ChartBreakout/ChartBreakoutSquare';
import NotificationText from 'src/app/icons/Monospaced/Notification/NotificationText';
import ArrowSquareUpRight from 'src/app/icons/Monospaced/ArrowSquare/ArrowSquareUpRight';
import LayoutTop from 'src/app/icons/Monospaced/Layout/LayoutTop';
import Award03 from 'src/app/icons/Monospaced/Award/Award03';
import { cssVar } from 'src/app/styles/helper';
import { FeaturesStack } from './ProductsMegaMenu.styles';
import Typography from 'src/app/atoms/Typography/Typography';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import MegaMenuLink from 'src/app/molecules/Header/MegaMenu/MegaMenuLink';
import Stack from 'atoms/Layout/Stack/Stack';

const featureLinks = [
  {
    label: 'Courses & Challenges',
    href: '/product/online-courses',
    icon: (
      <GraduationHat
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Landing Pages',
    href: '/product/landing-pages',
    icon: (
      <LayoutTop
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Events & Livestreaming',
    href: '/product/events-livestreaming',
    icon: (
      <CalendarDate
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Payments',
    href: '/product/payments',
    icon: (
      <CurrencyDollar
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Members',
    href: '/product/members',
    icon: (
      <UserCircle
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Embeds & Integrations',
    href: '/product/embeds-integrations',
    icon: (
      <CodeSnippet
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'People Magic AI',
    href: '/product/ai',
    icon: (
      <Stars02
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Automations',
    href: '/product/automations',
    icon: (
      <Repeat01
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Chat',
    href: '/product/chat',
    icon: (
      <MessageChatCircle
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Admin & Management',
    href: '/product/admin',
    icon: (
      <Settings01
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Activity Feed',
    href: '/product/feed',
    icon: (
      <NotificationText
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Analytics',
    href: '/product/analytics',
    icon: (
      <ChartBreakoutSquare
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Gamification',
    href: '/product/gamification',
    icon: (
      <Award03
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'All Features',
    href: '/product',
    icon: (
      <ArrowSquareUpRight
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
];

const ProductsMegaMenuFeatures = (): JSX.Element => {
  return (
    <FeaturesStack
      direction='column'
      align='stretch'
      justify='flex-start'
      gap={'spacing-lg'}
      padding={['spacing-3xl', 'spacing-3xl', 'spacing-3xl', 'spacing-none']}
      paddingLg='spacing-xl'
    >
      <Typography
        type='paragraph'
        size='sm'
        fontWeight='font-weight-semibold'
        color='text-brand-secondary'
      >
        Features
      </Typography>
      <Grid
        totalColumns={2}
        totalColumnsLg={1}
      >
        <Stack direction='column'>
          {featureLinks
            .filter((_, i) => i % 2 === 0)
            .map((link) => (
              <MegaMenuLink
                key={link.label}
                {...link}
              />
            ))}
        </Stack>
        <Stack direction='column'>
          {featureLinks
            .filter((_, i) => i % 2 === 1)
            .map((link) => (
              <MegaMenuLink
                key={link.label}
                {...link}
              />
            ))}
        </Stack>
      </Grid>
    </FeaturesStack>
  );
};

export default ProductsMegaMenuFeatures;
